import React from 'react';
import {Link} from 'react-router-dom';
import bg3  from './../assets/images/background/bg3.jpg';
const PageTitle = ({parentPage, childPage,PageName})=>{
    return(
        <>
            <div className="dz-bnr-inr" >
                <div className="container">
                    <div className="dz-bnr-inr-entry">
                        <h1 style={{display:"none"}}>{childPage}</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row ">
                            <ul className="breadcrumb ">
                                <li className="breadcrumb-item  "><Link className="" to={PageName}>{parentPage}</Link></li>
                                <li className="breadcrumb-item ">{childPage}</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    )
}
export default PageTitle;